// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import InputWrapper from '../InputWrapper';

// Types
import { formikInjectedPropsTypes } from '../../../../../lib/validation/propTypes/formikPropTypes';

/**
 * @visibleName Text
 */
const InputTextUpper = ({ className, ...props }) => (
  <InputWrapper
    {...props}
    type="text"
    upperCase={true}
    className={classnames('input-text', className)}
  />
);

InputTextUpper.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  formikProps: formikInjectedPropsTypes.isRequired,
};

export default InputTextUpper;
